import React from 'react';
import {Modal, ScrollView, View} from 'react-native';
import Button from '../../../../components/Button';
import Div from '../../../../lib/Div';
import MainStyle from '../../../../../MainStyle';
import {colors} from '../../../../assets/styles/colors';
import {Promo} from "../../../../../generated/smg_service_pb";
import moment from "moment";
import {isFullSwing} from "../../../../constants";
import P from "../../../../lib/P";

type Props = { promo?: Promo, onClose: () => void };

const PromoFeedbackModal = (props: Props) => {
  const {promo} = props;

  const calculateBonusMultiplier = (amount?: number, turnoverAmount?: number) => {
    const multiplier = Math.floor((turnoverAmount || 0) / (amount || 0));
    return `${multiplier}X`;
  };

  const getStatusColor = (status?: string) => {
    switch (status?.toUpperCase()) {
      case 'LIVE':
        return `#1CE783`;
      case 'UNUSED':
        return '#007BC1';
      case 'USED':
        return `#FABF41`;
      case 'EXPIRED':
        return `#FF6262`;
      default:
        return colors.white;
    }
  };

  return (
    <Modal animationType="fade" transparent visible={!!promo} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg={isFullSwing ? '#131314' : colors.settings_bg} w={389} h={452} rounded={20} overflow="hidden"
                 borderColor={colors.settings_border} borderWidth={1} pt={isFullSwing ? 0 : 46} minH={400} pb={41}>
              <P ta="center" fs={26} mb={42} fw="500" bg={isFullSwing ? '#252526' : undefined}
                 lh={isFullSwing ? 48 : undefined}>
                Promo Activated
              </P>

              <P ta="center" fs={22} fw="500">{promo?.name}</P>

              <Div row alignItems='center' mt={27} mb={22} px={52}>
                <Div flex={33.33} h={49} borderRightColor='rgba(255, 255, 255, 0.10)' borderRightWidth={1}>
                  <P ta="center" fs={14} tt="uppercase" mb={6} fw="500">AMOUNT</P>
                  <P ta="center" fs={24} fw="500">${Number(promo?.amount || 0) / 100}</P>
                </Div>

                <Div flex={33.33} h={49} borderRightColor='rgba(255, 255, 255, 0.10)' borderRightWidth={1}>
                  <P ta="center" fs={14} tt="uppercase" mb={6} fw="500">TURNOVER</P>
                  <P ta="center" fs={24} fw="500">
                    {calculateBonusMultiplier(promo?.amount === undefined ? undefined : Number(promo.amount), promo?.turnoverAmount === undefined ? undefined : Number(promo.turnoverAmount))}
                  </P>
                </Div>

                <Div flex={33.33} h={49}>
                  <P ta="center" fs={14} tt="uppercase" mb={8} fw="500">status</P>
                  <P color={getStatusColor(promo?.status)} ta="center" fw="700">{promo?.status}</P>
                </Div>
              </Div>

              <Div alignItems='center' w={'100%'}>
                <Div row alignItems='center' w={184} mx="auto">
                  <Div w={66}><P fs={14} tt="uppercase" fw="500">TYPE</P></Div>
                  <Div><P fw="700">{promo?.type.toUpperCase()}</P></Div>
                </Div>

                <Div row alignItems='center' w={184} mx="auto" mt={7}>
                  <Div w={66}><P fs={14} tt="uppercase" fw="500">EXP</P></Div>
                  {!!promo?.expirationDate && (
                    <Div>
                      <P fw="700">{moment.unix(Number(promo?.expirationDate)).format('ll').toUpperCase()}</P>
                    </Div>
                  )}
                </Div>
              </Div>

              <Div px={40} mt={36}>
                <Button
                  color={isFullSwing ? 'white' : '#0B1321'} radius={isFullSwing ? 4 : undefined} fontSize={22}
                  fontWeight="600" text="OK" onPress={props.onClose} bg={isFullSwing ? '#3369FF' : undefined}
                />
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default PromoFeedbackModal;
